import { FunctionComponent } from "react";
import { Collapse } from "antd";
import { ReactComponent as LightOnSmall } from "../../static/images/light-on-small.svg";
import { ReactComponent as Light } from "../../static/images/light.svg";
import { FaqResponseDto } from "@state/em_faq/dto/faq.response.dto";
import HTMLReactParser from "html-react-parser";

const { Panel } = Collapse;

interface FaqAccordionsProps {
  faq: FaqResponseDto[];
  className?: string;
}

const FaqAccordions: FunctionComponent<FaqAccordionsProps> = ({
  faq,
  className = "",
}) => {
  return (
    <Collapse
      accordion
      destroyInactivePanel
      expandIconPosition="right"
      className={`app-accordions ${className}`}
    >
      {faq.map((item, index) => (
        <Panel key={index.toString()} header={item.title}>
          <div className="accordion-answers">
            {item.answers?.map((answer) => (
              <div className="accordion-answer" key={answer.order}>
                <div className="d-flex align-items-center mb-3">
                  <div className="answer-title-icon d-none d-sm-block">
                    <LightOnSmall aria-hidden="true" focusable="false" />
                  </div>
                  <div className="answer-title">{answer.title}</div>
                </div>
                <div className="ms-sm-4 text-sm">
                  {HTMLReactParser(answer.content)}
                </div>
                {answer.tip && (
                  <div className="answer-tip-container d-flex align-items-start mt-3">
                    <div className="answer-tip-icon">
                      <Light aria-hidden="true" focusable="false" />
                    </div>
                    <div className="text-sm">{answer.tip}</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default FaqAccordions;
